<script>
export default {
	name: 'IconSvgForward',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<template>
	<div>
		<svg :width="size" :height="size" viewBox="0 0 27 21" :fill='color' xmlns="http://www.w3.org/2000/svg">
			<path d="M1.33334 1.6665H15.1795M1.33334 10.6665H25.3333M1.33334 19.6665H19.7949" :stroke="color"
				  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>

	</div>

</template>

<style scoped>

</style>